module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/battle-payments-cancel.941930ef.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/battle-payments-cancel.png
// module id = 3734
// module chunks = 11